import clsx from 'clsx'
import styles from './Arrow.module.css'

export const Arrow = (flipped?: boolean) => /*HTML*/ `
<svg class="${clsx(styles.Main, flipped && styles.Flipped)}" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
<path  d="M7.49068 1.625L0.999559 1.625L0.999559 0.375L9.62456 0.375L9.62456 9H8.37456L8.37456 2.50888L1.4415 9.44194L0.557617 8.55806L7.49068 1.625Z" />
</svg>
`
